import React, { useEffect, useRef, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { Helmet } from "react-helmet-async";

export default function Contact() {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  const [successMessage, setSuccessMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const formRef = useRef();

  const sendEmail = async (e) => {
    e.preventDefault();

    const form = formRef.current;
    const name = form.name.value.trim();
    const email = form.email.value.trim();
    const subject = form.subject.value.trim();
    const message = form.message.value.trim();

    const nameError    = document.getElementById("name-error");
    const emailError   = document.getElementById("email-error");
    const subjectError = document.getElementById("subject-error");
    const messageError = document.getElementById("message-error");
    const generalError = document.getElementById("general-error");

    nameError.innerText    = "";
    emailError.innerText   = "";
    subjectError.innerText = "";
    messageError.innerText = "";
    generalError.innerText = "";

    let hasError = false;

    if (!name) {
      nameError.innerText = "Please enter your name";
      hasError = true;
    }
    if (!email) {
      emailError.innerText = "Please enter your email";
      hasError = true;
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      emailError.innerText = "Please enter a valid email";
      hasError = true;
    }
    if (!subject) {
      subjectError.innerText = "Please enter a subject";
      hasError = true;
    }
    if (!message) {
      messageError.innerText = "Please enter your message";
      hasError = true;
    }

    if (hasError) return;

    setIsLoading(true);

    try {
      const formData = new FormData(form);

      const response = await fetch(
        "https://formsubmit.co/ajax/info@technicmentors.com",
        {
          method: "POST",
          headers: {
            Accept: "application/json",
          },
          body: formData,
        }
      );

      const result = await response.json();

      if (result.success === "true" || result.success === true) {
        formRef.current.reset();
        setSuccessMessage("Message sent successfully! We'll get back to you soon.");
        setTimeout(() => setSuccessMessage(""), 5000);
      } else {
        generalError.innerText = "Failed to send message. Please try again.";
      }
    } catch (error) {
      generalError.innerText = "Failed to send message. Please try again.";
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>Get In Touch With Us - Technic Mentors</title>
        <link rel="canonical" href="https://technicmentors.com/contact/" />
      </Helmet>

      <div style={{ backgroundColor: "#f1f6fe" }} className="background-img5">
        <div className="color-overlay5">
          <div className="allHeaderBg">
            <div className="allHeader-overlay d-flex align-items-center justify-content-center">
              <div>
                <h1 className="head text-center text-white animate__animated animate__zoomIn allHeaderP">
                  Contact Us
                </h1>
              </div>
            </div>
          </div>

          <div className="container py-5">
            <div
              className="row g-5 d-flex align-items-stretch"
            >
              {/* Left Side - Info + Map */}
              <div className="col-lg-6 d-flex" data-aos="fade-right">
                <div
                  className="p-4 p-lg-5 w-100"
                  style={{
                    backgroundColor: "white",
                    borderRadius: "20px",
                    boxShadow: "0 10px 40px rgba(0,0,0,0.08)",
                  }}
                >
                  <h2 className="display-5 fw-bold mb-4" style={{ color: "#684df4" }}>
                    Let's Connect
                  </h2>
                  <p className="lead mb-4" style={{ color: "#424242", lineHeight: "1.8" }}>
                    Have a question or ready to start your next project? Reach out — we're here to help 24/7.
                  </p>

                  <div className="mb-5">
                    <div className="d-flex align-items-start mb-4">
                      <div
                        className="me-3"
                        style={{
                          width: "52px",
                          height: "52px",
                          borderRadius: "14px",
                          backgroundColor: "#e3f2fd",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <i className="bx bx-map bx-md" style={{ color: "#684df4" }}></i>
                      </div>
                      <div>
                        <h5 className="mb-1" style={{ color: "#684df4" }}>Our Locations</h5>
                        <p className="mb-0" style={{ color: "#616161" }}>
                          United Kingdom | Norway | Pakistan
                        </p>
                      </div>
                    </div>

                    <div className="d-flex align-items-start mb-4">
                      <div
                        className="me-3"
                        style={{
                          width: "52px",
                          height: "52px",
                          borderRadius: "14px",
                          backgroundColor: "#f3e5f5",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <i className="bx bx-envelope bx-md" style={{ color: "#684df4" }}></i>
                      </div>
                      <div>
                        <h5 className="mb-1" style={{ color: "#684df4" }}>Email Us</h5>
                        <a
                          href="mailto:info@technicmentors.com"
                          style={{ color: "#684df4", textDecoration: "none", fontWeight: "500" }}
                        >
                          info@technicmentors.com
                        </a>
                      </div>
                    </div>

                    <div className="d-flex align-items-start">
                      <div
                        className="me-3"
                        style={{
                          width: "52px",
                          height: "52px",
                          borderRadius: "14px",
                          backgroundColor: "#e8f5e9",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <i className="bx bx-phone-call bx-md" style={{ color: "#684df4" }}></i>
                      </div>
                      <div>
                        <h5 className="mb-1" style={{ color: "#684df4" }}>Call Us</h5>
                        <p className="mb-0" style={{ color: "#616161" }}>
                          +923 111 122 144
                        </p>
                      </div>
                    </div>
                  </div>

                  <div
                    className="rounded-3 overflow-hidden shadow flex-grow-1"
                    style={{ border: "1px solid #e0e0e0", minHeight: "320px" }}
                    data-aos="zoom-in"
                    data-aos-delay="200"
                  >
                    <iframe
                      src="https://www.google.com/maps/d/u/0/embed?mid=1DGgSINjLUssm-lD0CO8LjBztg3FiAZE&ehbc=2E312F"
                      title="Our Locations"
                      width="100%"
                      height="100%"
                      style={{ border: 0, minHeight: "320px" }}
                      allowFullScreen
                      loading="lazy"
                    ></iframe>
                  </div>
                </div>
              </div>

              {/* Right Side - Form */}
              <div className="col-lg-6 d-flex" data-aos="fade-left">
                <div
                  className="p-4 p-lg-5 w-100"
                  style={{
                    backgroundColor: "white",
                    borderRadius: "20px",
                    boxShadow: "0 10px 40px rgba(0,0,0,0.08)",
                  }}
                >
                  <h3 className="mb-4 fw-bold" style={{ color: "#684df4" }}>
                    Send Us a Message
                  </h3>

                  {successMessage && (
                    <div
                      className="alert mb-4"
                      style={{
                        backgroundColor: "#e3f2fd",
                        color: "#684df4",
                        border: "1px solid #c5e0ff",
                        borderRadius: "10px",
                      }}
                    >
                      {successMessage}
                    </div>
                  )}

                  <div
                    id="general-error"
                    className="text-danger text-center mb-3"
                    style={{ fontSize: "14px" }}
                  ></div>

                  <form ref={formRef} onSubmit={sendEmail}>

                    {/* FormSubmit Hidden Config Fields */}
                    <input type="hidden" name="_subject" value="New Contact - Technic Mentors" />
                    <input type="hidden" name="_captcha" value="false" />
                    <input type="hidden" name="_template" value="table" />
                    <input type="hidden" name="_cc" value="mrnadeemmunir@gmail.com" />
                    <input
                      type="hidden"
                      name="_autoresponse"
                      value="Thank you for contacting Technic Mentors! We have received your message and will get back to you soon."
                    />

                    <div className="mb-3">
                      <label
                        htmlFor="name"
                        className="form-label fw-semibold"
                        style={{ color: "#424242" }}
                      >
                        Full Name
                      </label>
                      <input
                        type="text"
                        name="name"
                        className="form-control"
                        id="name"
                        placeholder="John Doe"
                        style={{
                          padding: "12px 16px",
                          borderRadius: "10px",
                          border: "2px solid #e0e0e0",
                        }}
                      />
                      <div
                        id="name-error"
                        className="text-danger mt-1"
                        style={{ fontSize: "14px" }}
                      ></div>
                    </div>

                    <div className="mb-3">
                      <label
                        htmlFor="email"
                        className="form-label fw-semibold"
                        style={{ color: "#424242" }}
                      >
                        Email Address
                      </label>
                      <input
                        type="email"
                        name="email"
                        className="form-control"
                        id="email"
                        placeholder="john@example.com"
                        style={{
                          padding: "12px 16px",
                          borderRadius: "10px",
                          border: "2px solid #e0e0e0",
                        }}
                      />
                      <div
                        id="email-error"
                        className="text-danger mt-1"
                        style={{ fontSize: "14px" }}
                      ></div>
                    </div>

                    <div className="mb-3">
                      <label
                        htmlFor="subject"
                        className="form-label fw-semibold"
                        style={{ color: "#424242" }}
                      >
                        Subject
                      </label>
                      <input
                        type="text"
                        name="subject"
                        className="form-control"
                        id="subject"
                        placeholder="Project Inquiry / Support Request"
                        style={{
                          padding: "12px 16px",
                          borderRadius: "10px",
                          border: "2px solid #e0e0e0",
                        }}
                      />
                      <div
                        id="subject-error"
                        className="text-danger mt-1"
                        style={{ fontSize: "14px" }}
                      ></div>
                    </div>

                    <div className="mb-3">
                      <label
                        htmlFor="message"
                        className="form-label fw-semibold"
                        style={{ color: "#424242" }}
                      >
                        Your Message
                      </label>
                      <textarea
                        name="message"
                        className="form-control"
                        id="message"
                        rows="6"
                        placeholder="How can we help you today?"
                        style={{
                          padding: "12px 16px",
                          borderRadius: "10px",
                          border: "2px solid #e0e0e0",
                          resize: "vertical",
                        }}
                      ></textarea>
                      <div
                        id="message-error"
                        className="text-danger mt-1"
                        style={{ fontSize: "14px" }}
                      ></div>
                    </div>

                    <button
                      type="submit"
                      disabled={isLoading}
                      className="btn w-100 mt-3 py-3 fw-semibold"
                      style={{
                        backgroundColor: "#684df4",
                        color: "white",
                        borderRadius: "10px",
                        border: "none",
                        fontSize: "16px",
                        transition: "all 0.3s",
                        opacity: isLoading ? 0.7 : 1,
                        cursor: isLoading ? "not-allowed" : "pointer",
                      }}
                    >
                      {isLoading ? "Sending..." : "Send Message"}
                      {!isLoading && <i className="bx bx-paper-plane ms-2"></i>}
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}